import { Component, OnInit, ViewChild, ElementRef, inject, QueryList, ViewChildren } from '@angular/core';
import { MisReportColumnViewModel, misGroupReportModel } from '../Models/misReportMaster.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ReportserviceService } from '../reportservice.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { Observable, forkJoin, fromEvent, interval } from 'rxjs';
import { exhaustMap, take, tap } from 'rxjs/operators';
import { ExportService } from '../services/export.service';
declare const $: any;
import { DatePipe } from '@angular/common';
// import 'jspdf-autotable';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-mis-report',
  templateUrl: './mis-report.component.html',
  styleUrls: ['./mis-report.component.scss']
})
export class misReportComponent implements OnInit {
  visible: number = -1;
  leftNav: number = -1;
  addnewGroupArray: misGroupReportModel[] = [];
  ColumnViewArray: MisReportColumnViewModel[] = [];
  addnewGroupobject: misGroupReportModel = {};
  selectDateString: string = '';
  changeColumnArray: any = [];
  coldateFieldarray: MisReportColumnViewModel[] = [];
  headerFieldarray: MisReportColumnViewModel[] = [];
  showspinner: boolean = false;
  enabledisablegroup: boolean = false;
  enabledisabledisplay: boolean = false;
  enabledisableactual: boolean = false;
  maingroupbyArray: misGroupReportModel[] = [];
  reportcolumnobj:any={};
  startdate: any;
  enddate: any;
  displayName: string = '';
  isShowDivIf: boolean = false;
  reportAccessName: string = '';
  reportgroupbyName: string = '';
  Searchterm: any;
  ischangedate: boolean = true;
  noofdateAllowed: number = 0;
  constructor(private authservice: AuthService, public reportService: ReportserviceService, public dashboardService: DashboardService, public exportdata: ExportService, public datePipe: DatePipe) { }
  @ViewChildren('defaultauto') defaultautoRef: QueryList<ElementRef>;
  @ViewChild('content', { static: false }) content: ElementRef;
  ngOnInit(): void {
    this.startdate = this.dashboardService.selecteddate;
    this.enddate = this.dashboardService.selecteddate;

    this.getmisReportmaster();
  }
  ngAfterViewInit(): void {

    fromEvent(this.button.nativeElement, 'click')
      .pipe(
        tap((x) => this.showspinner = true),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());
  }
  @ViewChild('insertMisReportMasterbtn', { static: true }) button;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));

  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.insertMisReportMasterdata()
      },
      error: (err) => {

      },

    };

  }
  getmisReportmaster() {
    this.reportService.getMisReportMaster().subscribe((item: any) => {
      this.addnewGroupArray = [];
      this.maingroupbyArray = [];
      this.addnewGroupArray = item;
      this.maingroupbyArray = item.reduce((r, { groupName }) => {
        if (!r.some(o => o.groupName == groupName)) {
          r.push({ groupName, groupItem: item.filter(v => v.groupName == groupName) });
        }
        return r;
      }, []);
    }, err => {
      this.dashboardService.openSnackBar("API Failed", "OK");
    })
  }
  ongroupNamechange(e, index, checkid) {
    if (e != null && e != "") {
      this.enabledisablegroup = false;
      this.addnewGroupArray[index].groupName = e;
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    } else {
      this.addnewGroupArray[index].groupName = null;
      this.enabledisablegroup = true;
    }
  }
  ondisplayNamechange(e, index, checkid) {
    if (e != null && e != "") {
      this.enabledisabledisplay = false;
      this.addnewGroupArray[index].displayName = e;
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    } else {
      this.addnewGroupArray[index].displayName = null;
      this.enabledisabledisplay = true;

    }
  }
  onactualNameNamechange(e, index, checkid) {
    if (e != null && e != "") {
      this.enabledisableactual = false;
      this.addnewGroupArray[index].actualName = e;
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    } else {
      this.addnewGroupArray[index].actualName = null;
      this.enabledisableactual = true;
    }
  }
  onaorderByNamechange(e, index, checkid) {
    if (e != null) {
      this.addnewGroupArray[index].orderBy = e;
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    }
  }
  onmaxBackDaychange(e, index, checkid) {
    if (e != null) {
      this.addnewGroupArray[index].maxBackDay = e;
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    }
  }
  leftChildItem(index) {
    if (this.visible == index) {
      this.leftNav = -1;
      this.visible = -1;
    } else {
      this.leftNav = index; //not equal to condition
      this.visible = index;
      this.rowClicked = -1;
    }

  }
  isHeader(event: MatCheckboxChange) {
    this.isShowDivIf = event.checked;
  }
  isHeaderOptions(event: MatCheckboxChange, index, checkid) {
    if (event.checked != null) {
      this.addnewGroupArray[index].isHeader = event.checked == true ? 'Y' : 'N';
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    }
  }
  backDateAllowOptions(event: MatCheckboxChange, index, checkid) {
    if (event.checked != null) {
      this.addnewGroupArray[index].backDateAllow = event.checked == true ? 'Y' : 'N';
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    }
  }
  isGrandTotalOptions(event: MatCheckboxChange, index, checkid) {
    if (event.checked != null) {
      this.addnewGroupArray[index].isGrandTotal = event.checked == true ? 'Y' : 'N';
      this.addnewGroupArray[index].isEdit = checkid > 0 ? true : false;
    }
  }
  columnSettings() {
    document.getElementById("columnSettingsModal").style.display = "block";
  }
  cancelcolumnSettings() {
    document.getElementById("columnSettingsModal").style.display = "none";
  }

  addGroup() {
    this.enabledisableactual = false;
    this.enabledisabledisplay = false;
    this.enabledisablegroup = false;
    this.getmisReportmaster();
    document.getElementById("addGroupModal").style.display = "block";

  }
  canceladdGroup() {
    document.getElementById("addGroupModal").style.display = "none";
  }

  addNewGroup() {

    this.addnewGroupobject = {};
    this.enabledisableactual = true;
    this.enabledisabledisplay = true;
    this.enabledisablegroup = true;
    this.addnewGroupobject.isEdit = false;
    this.addnewGroupobject.pk_TranId = 0;
    this.addnewGroupobject.actualName = null;
    this.addnewGroupobject.backDateAllow = null;
    this.addnewGroupobject.isActive = true;
    this.addnewGroupobject.groupName = null;
    this.addnewGroupobject.displayName = null;
    this.addnewGroupobject.isHeader = null;
    this.addnewGroupobject.maxBackDay = 0;
    this.addnewGroupobject.orderBy = null;
    this.addnewGroupArray.push(this.addnewGroupobject);

    this.defaultautoRef.changes.pipe(take(1)).subscribe({
      next: changes => changes.last.nativeElement.focus()
    })
  }
  insertMisReportMasterdata() {
 
    if (this.addnewGroupArray.length > 0) {
      let checkvalue = this.addnewGroupArray.filter(i => !i.groupName || !i.displayName || !i.actualName);
      if (checkvalue.length > 0) {
        if (!checkvalue[0].groupName && !checkvalue[0].displayName && !checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("GroupName, ReportName & ViewName are Required", "OK");
        } else if (checkvalue[0].groupName && !checkvalue[0].displayName && !checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("ReportName & ViewName are Required", "OK");
        } else if (checkvalue[0].groupName && !checkvalue[0].displayName && checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("ReportName are Required", "OK");
        } else if (checkvalue[0].groupName && checkvalue[0].displayName && !checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("ViewName are Required", "OK");
        } else if (!checkvalue[0].groupName && checkvalue[0].displayName && checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("GroupName are Required", "OK");
        } else if (!checkvalue[0].groupName && !checkvalue[0].displayName && checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("GroupName & ReportName are Required", "OK");
        } else if (!checkvalue[0].groupName && checkvalue[0].displayName && !checkvalue[0].actualName) {
          this.dashboardService.openSnackBar("GroupName & ViewName are Required", "OK");
        }

        this.showspinner = false;
        return;
      }
      this.addnewGroupArray = this.addnewGroupArray.filter(i => i.groupName && i.displayName && i.actualName);
      const checkduplicate = this.addnewGroupArray.reduce((unique, o) => {
        if (!unique.some(obj => (obj.displayName.toLocaleLowerCase() === o.displayName.toLocaleLowerCase()) && (obj.groupName.toLocaleLowerCase() === o.groupName.toLocaleLowerCase()))) {
          unique.push(o);
        }
        return unique;
      }, []);
      // var valueArr = this.addnewGroupArray.map(function (item) { return item.displayName.toLocaleLowerCase() });
      // var isDuplicate = valueArr.some(function (item, idx) {
      //   return valueArr.indexOf(item) != idx
      // });
      if (this.addnewGroupArray.length != checkduplicate.length) {
        this.dashboardService.openSnackBar("Report Name Already Exist", "OK");
        this.showspinner = false;
        return;
      }
      this.addnewGroupArray.map(item => item.isActive = true);
      let payload = {
        "MisReportMaster": this.addnewGroupArray.filter(item => item.isEdit == true || item.pk_TranId == 0)
      }
      this.reportService.insertMisReportMaster(payload).subscribe(x => {
        this.getmisReportmaster();
        this.showspinner = false;
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK")
      }, err => {
        this.showspinner = false;
        this.dashboardService.openSnackBar("API Failed", "OK")
      })
    } else {
      this.showspinner = false;
      this.dashboardService.openSnackBar("Please Add NewGroup ", "OK")
    }

  }
  passusedata: any = [];
  getMisReportColumn(viewname, type) {
    if (viewname) {
      if (type == 0) {
        if (this.ColumnViewArray.length > 0) {
          document.getElementById("columnSettingsModal").style.display = "block";
        } else {
          this.dashboardService.openSnackBar("Select MIS report First", "OK");
        }

      } else {
        this.passusedata = [];
        var newarray = [];
        this.dataviewArray = [];
        this.ColumnViewArray = [];
        this.headerFieldarray = [];
        this.coldateFieldarray = [];
        this.selectDateString = '';
        var payloaddata = null;
        if (viewname.isSchemaOnDate && viewname.isSelfSchema) {
          payloaddata = {
            "MisReportmaster": {
              "viewname": viewname.actualName,
              "IsSelfSchema":viewname.isSelfSchema,
              "IsSchemaOnDate":viewname.isSchemaOnDate,
              "ToDate": this.datePipe.transform(this.enddate, "yyyy-MM-dd"),
              "FromDate": this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
            }
          }
        } else {
          payloaddata = {
            "MisReportmaster": {
              "viewname": viewname.actualName
            }
          }

        }
        forkJoin({
          usersavedata: this.reportService.get_misreport_data(this.authservice.Loggeduser.userid, viewname.actualName),
          defaultdata: this.reportService.getMisReportColumnView(payloaddata),
        }).subscribe(
          (results: any) => {
            var parvalue = [];
            if (results.usersavedata.length > 0) {
              this.passusedata = results.usersavedata;
              if (this.passusedata[0].reportConfiguration && this.passusedata[0].reportConfiguration.length > 0) {
                parvalue = JSON.parse(this.passusedata[0].reportConfiguration);
              }

            }
            if (results.defaultdata.length > 0) {
              results.defaultdata.forEach(item => {
                let newobject = {
                  "columnName": item.columnName,
                  "fieldType": item.fieldType,
                  "xusertype": item.xusertype,
                  "xtype": item.xtype,
                  "values": item.values == 'Y' ? true : false,
                  "grps": item.grps == 'Y' ? true : false,
                  "criteria": item.criteria != '' ? JSON.parse(item.criteria) : '',
                  "description": item.description,
                  "select": '',
                  "isEdit": false
                }
                newarray.push(newobject);
              });
            }
            if (parvalue.length > 0) {
              parvalue.forEach((item) => {
                for (var i = 0; i < newarray.length; i++) {

                  if (newarray[i].columnName == item["Column Name"]) {
                    newarray[i].columnName = item["Column Name"] ? item["Column Name"] : newarray[i].columnName;
                    newarray[i].values = item.SL;
                    newarray[i].grps = item.GR;
                    newarray[i].description = item.Description ? item.Description : newarray[i].description;
                    newarray[i].select = item.Select;
                  };
                }
              });

              this.changeColumnArray = [];
              this.reportgroupbyName = '';
              this.ColumnViewArray = newarray;
              const checkdata = this.ColumnViewArray.filter(item => item.isEdit == true);
              const checkgroupName = this.ColumnViewArray.filter(item => item.grps == true);
              this.reportgroupbyName = checkgroupName[0]?.columnName ? checkgroupName[0]?.columnName : '';
              this.headerFieldarray = this.ColumnViewArray.filter(item => item.values == true);
              this.coldateFieldarray = this.ColumnViewArray.filter(item => item.fieldType == 'datetime' || item.fieldType == 'date');
              this.selectDateString = this.coldateFieldarray[0]?.columnName ? this.coldateFieldarray[0]?.columnName : '';
              if (checkdata.length > 0) {
                checkdata.forEach(item => {
                  if (item.description && item.select) {
                    this.changeColumnArray.push({
                      "ColumnName": item.columnName,
                      "Svalue": item.description,
                      "selecttype": item.select,
                    });
                  }

                });
              }
            } else {
              this.ColumnViewArray = newarray;
              this.headerFieldarray = newarray;
              this.coldateFieldarray = newarray.filter(item => item.fieldType == 'datetime' || item.fieldType == 'date');
              this.selectDateString = this.coldateFieldarray[0]?.columnName ? this.coldateFieldarray[0]?.columnName : '';
            }


          });
      }

    } else {
      this.dashboardService.openSnackBar("ViewName Not Found", "OK");
    }
  }
  rowClicked: any;

  selectReportRow(rowdata, index) {
    console.log(rowdata);
    if (rowdata.actualName) {
      if (this.rowClicked === index) {
        this.coldateFieldarray = [];
        this.headerFieldarray = [];
        this.changeColumnArray = []
        this.rowClicked = -1;
        this.reportAccessName = '';
        this.reportgroupbyName = '';
        this.displayName = '';
        this.reportcolumnobj={};
        this.ischangedate = true;
        this.noofdateAllowed = 0;
      }
      else {
        this.changeColumnArray = []
        this.dataviewArray = [];
        this.datawithoutGroup = [];
        this.reportgroupbyName = '';
        this.isShowDivIf = rowdata.isHeader == 'Y' ? true : false;
        this.ischangedate = rowdata.backDateAllow == 'Y' ? false : true;
        this.noofdateAllowed = rowdata.backDateAllow == 'Y' ? rowdata.maxBackDay : 0;
        this.rowClicked = index;
        this.reportAccessName = rowdata.actualName;
        this.displayName = rowdata.displayName;
        this.reportcolumnobj =rowdata;
        this.getMisReportColumn(this.reportcolumnobj, 1);
      }
    } else {
      this.dashboardService.openSnackBar("ViewName Not Found", "OK");
    }
  }
  dataviewArray: any = [];
  datawithoutGroup: any = [];
  getReportdataView(actualname) {
   
    if (actualname) {
      this.reportService.postMisReportdataView(actualname).subscribe((x: any) => {

        this.dataviewArray = [];
        this.datawithoutGroup = [];
        if (x['misReportDataArray'] != null) {
          const parsedata = JSON.parse(x['misReportDataArray']);
          if (this.reportgroupbyName != '') {
            this.datawithoutGroup = parsedata;
          }

          let groupdataa = parsedata.reduce((r, key) => {
            let groupbydat = key[this.reportgroupbyName];
            if (!r.some(o => o.groupbydat == groupbydat)) {
              r.push({ groupbydat, branchItem: parsedata.filter(v => v[this.reportgroupbyName] == groupbydat) });
            }
            return r;
          }, []);
          this.dataviewArray = groupdataa;
        }


      }, err => {
        this.dashboardService.openSnackBar("API Failed", "OK");
      })
    } else {
      this.dashboardService.openSnackBar("ViewName Not Found", "OK");
    }

  }
  exportexcel() {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, this.displayName);

  }

  public openPDF(): void {
    if (this.headerFieldarray.length != 0) {
      if (this.headerFieldarray.length <= 13) {
        this.exportdata.open_loader_Dialogtwo();
        $("#removeclass").removeClass("grid-scroll");
        let DATA = document.getElementById('content');
        this.exportdata.getexportPDF(DATA, this.displayName);
        $("#removeclass").addClass("grid-scroll");

      } else {
        this.dashboardService.openSnackBar("You Can't Export PDF More than 13 Column", "OK");
      }
    }
  }




  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);

  }
  public printPDF(): void {
    if (this.headerFieldarray.length != 0) {
      if (this.headerFieldarray.length <= 13) {
        this.exportdata.printpDFData();
      } else {
        this.dashboardService.openSnackBar("You Can't print More than 13 Column", "OK");
      }
    }
  }
  Changesldata(event: MatCheckboxChange, index) {
    this.ColumnViewArray[index].values = event.checked;
    this.ColumnViewArray[index].isEdit = true;
  }
  checkdatetype: any = null;
  Changegrpdata(event: MatCheckboxChange, index, rowdata) {
    this.ColumnViewArray[index].grps = event.checked;
    this.ColumnViewArray[index].isEdit = true;
    this.checkdatetype = event.checked == true ? rowdata.fieldType : null;
  }
  changeSelectMethod(data, index) {
    this.ColumnViewArray[index].select = data;
    this.ColumnViewArray[index].isEdit = true;
  }
  changeDescMethod(data, index) {
    this.ColumnViewArray[index].description = data;
    this.ColumnViewArray[index].isEdit = true;
  }
  ChangeDataSetting() {

    this.changeColumnArray = [];
    this.reportgroupbyName = '';
    const checkdata = this.ColumnViewArray.filter(item => item.isEdit == true);
    const checkgroupName = this.ColumnViewArray.filter(item => item.grps == true);
    this.reportgroupbyName = checkgroupName[0]?.columnName ? checkgroupName[0]?.columnName : '';
    this.headerFieldarray = [];
    this.headerFieldarray = this.ColumnViewArray.filter(item => item.values == true);
    this.coldateFieldarray = [];
    this.selectDateString = '';
    this.coldateFieldarray = this.ColumnViewArray.filter(item => item.fieldType == 'datetime' || item.fieldType == 'date');
    this.selectDateString = this.coldateFieldarray[0]?.columnName ? this.coldateFieldarray[0]?.columnName : '';
    if (checkdata.length > 0) {
      checkdata.forEach(item => {
        if (item.description && item.select) {
          this.changeColumnArray.push({

            "ColumnName": item.columnName,
            // "fieldType": item.fieldType,
            //  "xusertype": item.xusertype,
            //  "xtype": item.xtype,
            //  "values": item.values == true ? 'Y' : 'N',
            //  "grps": item.grps == true ? 'Y' : 'N',
            "Svalue": item.description,
            "selecttype": item.select,
          });
        }

      });
    }
    var updatepayload = [];
    if (this.ColumnViewArray.length > 0) {
      for (var i = 0; i < this.ColumnViewArray.length; i++) {
        let npayload = {
          "Column Name": this.ColumnViewArray[i].columnName,
          "SL": this.ColumnViewArray[i].values,
          "GR": this.ColumnViewArray[i].grps,
          "Select": this.ColumnViewArray[i].select,
          "Description": this.ColumnViewArray[i].description
        }
        updatepayload.push(npayload);
      }
      const payload = {
        WebMisReportUserPermissionDetail: [
          {
            "Pk_WebMisReportUserPermissionDetail": this.passusedata.length > 0 ? this.passusedata[0].pk_WebMisReportUserPermissionDetail : 0,
            "FK_UserId": this.authservice.Loggeduser.userid,
            "ActualName": this.passusedata.length > 0 ? this.passusedata[0].actualName : this.reportAccessName,
            "ReportConfiguration": updatepayload,
            "IsActive": true,
            "FK_CreatedById": this.authservice.Loggeduser.userid,
            "IsEdit": this.passusedata.length > 0 ? true : false,
          }
        ]
      };

      this.reportService.insert_web_MisReportMaster(payload).subscribe(
        (response) => {

          this.dashboardService.openSnackBar('Record Saved Successfully', 'OK');
          document.getElementById("columnSettingsModal").style.display = "none";
        },
        (error) => {
          console.error('Post API Error:', error);
          this.dashboardService.openSnackBar("API Failed", "OK")
        }
      );
    }
    document.getElementById("columnSettingsModal").style.display = "none";
  }

  changedateField(event) {

    this.selectDateString = event;
  }
  filterFinalData() {
 
    if(this.reportcolumnobj){
      if(this.reportcolumnobj.isSchemaOnDate && this.reportcolumnobj.isSelfSchema){
        this.getMisReportColumn(this.reportcolumnobj, 1);
      }
    }  
   
    const columnNames = this.headerFieldarray .filter(d => d.fieldType !== 'float').map(d => d.columnName).join(',');
    const folatName =this.headerFieldarray
    .filter(d => d.fieldType == 'float')  // <-- your condition here
    .map(d => d.columnName)
    .join(',');
    if (this.ischangedate == true) {
     
      if (Date.parse(this.datePipe.transform(this.enddate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform(this.startdate, "yyyy-MM-dd").toString())) {
        if (this.reportAccessName) {
         
          let payload = {
            "MisReportmaster": {
              "viewname": this.reportAccessName,
              "DateColumnName": this.selectDateString,
              "ToDate": this.datePipe.transform(this.enddate, "yyyy-MM-dd"),
              "FromDate": this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
              "SelectedColumns":columnNames,
              "AggColumn":folatName
            },
            "MisReportMasterDataArray": this.changeColumnArray
          }
          this.getReportdataView(payload);
        } else {
          this.dashboardService.openSnackBar("Select Report First", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Please Select Correct Date Range  ", "OK");
      }
    } else {
      const cdate = new Date(this.authservice.localDate);
      cdate.setDate(cdate.getDate() - this.noofdateAllowed);
      if (Date.parse(this.datePipe.transform(this.startdate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform(cdate, "yyyy-MM-dd").toString())) {
        if (Date.parse(this.datePipe.transform(this.enddate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform(this.startdate, "yyyy-MM-dd").toString())) {
          if (this.reportAccessName) {
          
            let payload = {
              "MisReportmaster": {
                "viewname": this.reportAccessName,
                "DateColumnName": this.selectDateString,
                "ToDate": this.datePipe.transform(this.enddate, "yyyy-MM-dd"),
                "FromDate": this.datePipe.transform(this.startdate, "yyyy-MM-dd"),
                "SelectedColumns":columnNames,
                "AggColumn":folatName
              },
              "MisReportMasterDataArray": this.changeColumnArray
            }
            this.getReportdataView(payload);
          } else {
            this.dashboardService.openSnackBar("Select Report First", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Select Correct Date Range  ", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("No of Back Date Allowed " + this.noofdateAllowed, "OK");
      }
    }
  
  }

  returndata(arraydata: any, colname) {

    let colnameformat = colname ? colname : colname;

    var col0 = arraydata.map((d) => Number.parseInt(d[colnameformat])).reduce((acc, curr) => acc ? acc + (curr ? curr : 0) : 0 + (curr ? curr : 0), 0);

    return col0;
  }
  isHeaderSelectAll(event: MatCheckboxChange) {
    if (event.checked == true) {
      this.ColumnViewArray.forEach((item, i) => {
        this.ColumnViewArray[i].values = true;
      });

      this.headerFieldarray = this.ColumnViewArray;
    }
  }

}
